<template>
  <div class="dept_container">
    <div class="department_title">
      岗位查询
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="部门名称：">
        <el-input
          v-model="formInline.postName"
          placeholder="请输入岗位名称"
          clearable
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="状态：" class="left_margin">
        <el-select v-model="formInline.status" placeholder="岗位状态" clearable>
          <el-option label="正常" value="0"></el-option>
          <el-option label="停用" value="1"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- 时间选择器 -->
      <!-- <el-form-item label="创建时间：" class="left_margin">
        <el-date-picker
          v-model="time"
          value-format="yyyy-MM-dd"
          type="daterange"
          size="small"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          prefix-icon="el-icon-date"
        >
        </el-date-picker>
      </el-form-item> -->
      <el-form-item class="left_margin">
        <el-button type="primary" @click="onSubmit" class="inquire"
          >搜索</el-button
        >
        <el-button type="primary" class="reset" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="newly_built">
      <el-button
        type="primary"
        icon="el-icon-plus"
        class="newly_built_btn"
        @click="addNewPotsBtn"
        v-if="premission('system:post:add')"
        >新建</el-button
      >
    </div>

    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      lazy
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="postName" label="岗位名称"> </el-table-column>
      <el-table-column prop="postSort" label="排序"> </el-table-column>
      <el-table-column prop="createBy" label="修改人"> </el-table-column>
      <el-table-column prop="createTime" label="修改日期"> </el-table-column>
      <el-table-column label="是否显示">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#F6B439"
            inactive-color="#ff4949"
            active-value="0"
            inactive-value="1"
            @change="switch_value_btn(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="operation_right"
            icon="el-icon-edit-outline"
            @click="compile(scope.row)"
            v-if="premission('system:post:edit')"
            >编辑</el-button
          >
          <el-button
            type="text"
            icon="el-icon-delete"
            @click="Delete(scope.row)"
            v-if="premission('system:post:remove')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑岗位弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :model="sizeForm"
        :rules="rules"
        label-width="110px"
        size="mini"
      >
        <el-form-item label="岗位名称：" prop="postName">
          <el-input
            v-model="sizeForm.postName"
            placeholder="请输入岗位名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="岗位排序：" prop="postSort">
          <el-input
            v-model="sizeForm.postSort"
            placeholder="请填写排序,数字越小越靠前"
          ></el-input>
        </el-form-item>
        <el-form-item label="显示状态：">
          <el-radio v-model="sizeForm.status" label="0">显示</el-radio>
          <el-radio v-model="sizeForm.status" label="1">不显示</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="cancel"
          >取 消</el-button
        >
        <el-button type="primary" @click="add_new_btn" class="add_new_btn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <div class="paging">
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[8, 15, 30]"
          :page-size="8"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import premission from "../../utils/permission";
import {
  updatePost,
  PostListsAjax,
  PostDeleteAjax,
  AddPostAjax,
  getPost
} from "../../api/index";
export default {
  mixins: [premission],
  data() {
    return {
      // 节流阀
      throttle: "true",
      // 表单验证
      rules: {
        postName: [
          { required: true, message: "岗位名称不能为空", trigger: "blur" }
        ],
        postSort: [
          { required: true, message: "岗位排序不能为空", trigger: "blur" }
        ]
      },
      // 时间组件
      time: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      // 新增编辑
      title: "",
      total: 0,
      currentPage: 1,
      // 新建公司弹窗
      dialogVisible: false,
      // 搜索数据
      formInline: {
        pageNum: 1,
        pageSize: 8,
        postName: undefined,
        status: undefined
      },

      // 新建公司数据
      sizeForm: {
        postName: "",
        postSort: "",
        status: "0"
      },
      // 表单数据
      tableData: []
    };
  },
  created() {
    this.getPostListsAjax();
  },
  methods: {
    //搜索
    async onSubmit() {
      if (!this.throttle) return;
      this.throttle = false;
      const { data: res } = await PostListsAjax(this.formInline);
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.tableData = res.rows;
      this.total = res.total;
      this.throttle = true;
    },
    // 重置
    reset() {
      this.formInline.status = "";
      this.formInline.postName = "";
      this.getPostListsAjax();
    },
    // 获取表单数据
    async getPostListsAjax() {
      const { data: res } = await PostListsAjax(this.formInline);
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.tableData = res.rows;
      this.total = res.total;
    },
    addNewPotsBtn() {
      this.title = "新增岗位";
      this.dialogVisible = true;
    },
    // 修改开关状态
    switch_value_btn(row) {
      let text = row.status === "0" ? "显示" : "隐藏";
      this.$confirm(
        '确认要"' + text + '""' + row.postName + '"菜单吗?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          const { data: res } = await updatePost({
            postId: row.postId,
            status: row.status,
            postName: row.postName,
            postSort: row.postSort
          });
          if (res.code !== 200) {
            row.status = row.status === "0" ? "1" : "0";
            return this.$message({
              type: "error",
              message: res.msg
            });
          }
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getPostListsAjax();
        })
        .catch(() => {
          row.status = row.status === "0" ? "1" : "0";
        });
    },
    // 新建公司
    async add_new_btn() {
      if (!this.throttle) return;
      this.throttle = false;
      if (this.title == "新增岗位") {
        const { data: res } = await AddPostAjax(this.sizeForm);
        if (res.code !== 200) {
          return this.$message({
            type: "error",
            message: res.msg
          });
        } else {
          this.dialogVisible = false;
          this.sizeForm = {
            postName: "",
            postSort: "",
            status: "0"
          };
          this.throttle = true;
          this.getPostListsAjax();
          return this.$message({
            type: "success",
            message: res.msg
          });
        }
      }
      if (this.title == "编辑岗位") {
        const { data: res } = await updatePost(this.sizeForm);
        if (res.code !== 200) {
          return this.$message({
            type: "error",
            message: res.msg
          });
        } else {
          this.dialogVisible = false;
          this.sizeForm = {
            postName: "",
            postSort: "",
            status: "0"
          };
          this.throttle = true;
          this.getPostListsAjax();
          return this.$message({
            type: "success",
            message: res.msg
          });
        }
      }
    },
    // 编辑按钮
    async compile(row) {
      console.log(row);
      this.title = "编辑岗位";
      this.dialogVisible = true;
      const { data: res } = await getPost(row.postId);
      this.sizeForm = res.data;
    },
    // 新建公司弹窗确认和取消
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
          this.dialogVisible = false;
          this.sizeForm = {
            postName: "",
            postSort: "",
            status: "0"
          };
        })
        .catch(_ => {});
    },
    handleSelectionChange(val) {
      console.log(val);
    },
    // 删除部门
    Delete(e) {
      this.open(e);
    },
    open(e) {
      this.$confirm(`是否确认删除名称为"${e.postName}"的数据项？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const { data: res } = await PostDeleteAjax(e.postId);
          if (res.code !== 200)
            return this.$message({
              type: "error",
              message: res.msg
            });
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getPostListsAjax();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 分页
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.onSubmit();
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.onSubmit();
    }
  }
};
</script>

<style lang="less" scoped>
.department_title {
  width: 72px;
  height: 24px;
  font-size: 18px;
  line-height: 24px;
  color: #171a1e;
  margin-bottom: 20px;
}
/deep/.demo-form-inline {
  .el-input__inner {
    width: 250px;
    height: 36px;
    font-size: 14px;
  }
  .left_margin {
    margin-left: 26px;
  }
  .inquire {
    width: 72px;
    height: 36px;
    margin-top: 2px;
    margin-left: -12px;
  }
  .el-button + .el-button {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background: #f6b439;
    border: 1px solid #f6b439;
  }
}
.newly_built {
  margin-top: 18px;
  margin-bottom: 20px;
  .newly_built_btn {
    width: 80px;
    height: 36px;
    text-align: center;
    padding: 0;
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
}
.operation_right {
  margin-right: 20px;
}

/deep/.el-table th {
  text-align: center;
  background-color: #f2f2f2;
}
/deep/ .el-table__row td {
  text-align: center;
  height: 60px;
  padding: 4px 0;
}

.dialog-footer {
  .add_new_btn {
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
  .cancel {
    background: #f2f2f2;
    border: 1px solid #e1e1e1;
  }
}
/deep/.el-dialog__header {
  .el-dialog__title {
    font-weight: normal;
  }
}
/deep/.el-form-item--mini.el-form-item {
  margin-bottom: 30px;
}
/deep/.el-form-item--mini .el-form-item__label {
  font-weight: normal;
  font-size: 16px;
}
/deep/.el-dialog {
  border-radius: 10px;
  padding: 10px 16px;
  .el-dialog__headerbtn {
    top: 36px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #000;
  }
}
/deep/.el-input--mini .el-input__inner {
  height: 32px;
  line-height: 36px;
  font-size: 16px;
}
/deep/.el-range-separator {
  width: 10%;
}
/deep/.el-range-editor.el-input__inner {
  float: left;
  margin-top: 2px;
}

/deep/ .el-date-editor .el-range__close-icon {
  line-height: 30px;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 28px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f6b439;
}
/deep/.el-pagination .el-select .el-input .el-input__inner {
  color: #999999;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #f6b439;
  background: #f6b439;
  width: 24px;
  height: 24px;
}
/deep/.el-radio__label {
  font-size: 16px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #f6b439;
}
/deep/.el-radio__inner {
  width: 24px;
  height: 24px;
}
/deep/.el-radio__inner::after {
  width: 10px;
  height: 10px;
}
.el-dialog__footer {
  button {
    text-align: center;
    line-height: 13px;
    width: 72px;
    height: 36px;
  }
}
.paging {
  margin-top: 40px;
  margin-left: 610px;
}
</style>
